import React, { useState, useEffect } from 'react'
import { Switch } from 'antd';
import { io } from "socket.io-client";
import { url , header } from "../Constent/Constant";


const socket = io(url, {
    path: '/custom',
    reconnection: true,
    reconnectionAttempts: 3,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    timeout: 20000,
    autoConnect: true,
    query: {},
    // options of the Engine.IO client
    upgrade: true,
    forceJSONP: false,
    jsonp: true,
    forceBase64: false,
    enablesXDR: false,
    timestampRequests: true,
    timestampParam: 't',
    policyPort: 843,
    transports: ['websocket'],
    transportOptions: {},
    rememberUpgrade: false,
    onlyBinaryUpgrades: false,
    requestTimeout: 0,
    protocols: [],
    // options for Node.js
    agent: false,
    pfx: null,
    key: null,
    passphrase: null,
    cert: null,
    ca: null,
    ciphers: [],
    rejectUnauthorized: true,
    perMessageDeflate: true,
    forceNode: false,
    localAddress: null,
}
);

socket.connect();

const Chat = () => {
    const [ChatShow, setChatShow] = useState(true)
    const [MessageShow, setMessageShow] = useState(false)
    const [UserMessages, setUserMessages] = useState('')
    const [UserId, setUserId] = useState('')
    const [MessageSend, setMessageSend] = useState('')
    const [ChatUsers, setChatUsers] = useState('')
    const [UserName, setUserName] = useState('User')
    const AdminId = localStorage.getItem('MS-AdminId')


    const OnMessageSend = () => {
        console.log('click')
        if (MessageSend === '') {

        } else {
            socket.emit('sendmessage', {
                msgsender: 'admin',
                textmsg: MessageSend,
                chatid: UserId,
                msgtype: 'text'
            })
            setMessageSend('')
        }
    }

    useEffect(() => {
        socket.on('messagesent', (message) => {
            console.log("Messages From User", message)
            setUserMessages(message.data.messages)
        })

        fetch(`${url}/chat/getchatssorted`)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                setChatUsers(data.doc)
            })
    }, [])

    const OnMessageShow = (name,messages,id) =>{
        setUserId(id)
        setUserMessages(messages)
        setMessageShow(true)
        setUserName(name)
    }

    const OnChangehandler = e => {
        console.log(e.target.files[0])
        const data = new FormData();
        data.append('image', e.target.files[0])
        fetch(`${url}/chat/uploadfile`, {
            method: "POST",
            body: data,
        })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                socket.emit('sendmessage', {
                    msgsender: 'admin',
                    imgmsglink: data.imgurl,
                    chatid: UserId,
                    msgtype: 'image'
                })
            })

    }

    const OnChatSwitch = (checked) => {
        console.log(checked)
        fetch(`${url}/admin/changeadminstatus`,{
            method:'Post',
            body:JSON.stringify({
              id:AdminId,
              status:checked
            }),
            headers:header
          })
          .then(res => res.json())
          .then(data => {
            console.log(data)
          })
    }


    const OnEnterPress = (event) => {
        if (event.key === 'Enter') {
          OnMessageSend()
        } else {
          console.log(event.key)
        }
      }

    console.log(UserMessages)

    return (
        <>
            {ChatShow && <div className='Chat-Container'>
                <div className='info'>
                    <h3>Users</h3>
                    <Switch onChange={OnChatSwitch} className='Chat-toggle' size="small" checkedChildren="On" unCheckedChildren="Off" defaultChecked />
                </div>
                <div className='Chat-users'>
                    {
                        ChatUsers ? ChatUsers.map(user => (
                            <div className='User-div' onClick={() => OnMessageShow(user.name,user.messages,user._id)} key={user._id}>
                                <div className='User-info'>
                                    <h3> {user.name} </h3>
                                    <p> {user.email} </p>
                                </div>
                                <div className='isRead'>
                                    {/* <h3>3</h3> */}
                                </div>
                            </div>
                        )) : <></>
                    }
                </div>
            </div>}

            {MessageShow && <div className='Message-Container'>
                <div className='User-name'>
                    <i onClick={() => {
                        setChatShow(true)
                        setMessageShow(false)
                    }} class="fas fa-arrow-left"></i>
                    <h2>{UserName}</h2>
                </div>
                <div className='Messages-div'>
                    {
                        UserMessages ? UserMessages.map(msg => (
                            msg.msgsender === 'user' ?
                                msg.msgtype === 'text' ? (
                                    <div className='admin-chat'>
                                        <p>{msg.textmsg}</p>
                                    </div>
                                ) : (
                                        <div className='admin-chat'>
                                            <img className='Chat-image-admin' src={`${url}/api/getFile${msg.imgmsglink}`} alt='imgg' />
                                        </div>
                                    )
                                : msg.msgtype === 'text' ? (
                                    <div className='client-chat'>
                                        <p>{msg.textmsg}</p>
                                    </div>
                                ) : (
                                        <div className=' client-chat'>
                                            <img className='Chat-image-client' src={`${url}/api/getFile${msg.imgmsglink}`} alt='imgg' />
                                        </div>
                                    )
                        )) : <></>
                    }

                </div>
                <div className='Message-Input'>
                    <div className='Hide-input-div'>
                        <input type='file' className='inputhide' onChange={OnChangehandler} />
                        <i class="far fa-images Option"></i>
                    </div>
                    <input value={MessageSend} onChange={e => setMessageSend(e.target.value)} className='Input' placeholder='Chat...' />
                    <i onKeyPress={(e) => OnEnterPress(e)} onClick={OnMessageSend} class="far fa-paper-plane Icon"></i>
                </div>
            </div>}
        </>
    )
}

export default Chat
